import { getId } from '@adalo/utils'

const INITIAL_STATE = {
  loading: false,
  appState: {
    applicationName: '',
    branding: {
      primary: '#00A898',
      secondary: '#FFC00E',
      background: '#FFFFFF',
      text: '#424242',
    },
  },
  messages: [
    {
      id: getId(),
      type: 'system',
      content: `Build Your App with Ada`,
      timestamp: new Date(),
    },
    {
      id: getId(),
      type: 'ai',
      content: `Hi I'm Ada, your Adalo AI Assistant! What type of app would you like to build?`,
      timestamp: new Date(),
    },
  ],
}

const SET_LOADING = Symbol('SET_LOADING')
const CHANGE_APP_STATE = Symbol('CHANGE_APP_STATE')
const ADD_MESSAGES = Symbol('ADD_MESSAGES')
const RESET_STATE = Symbol('RESET_STATE')

export const createApplicationAssistantActions = {
  SET_LOADING,
  CHANGE_APP_STATE,
  ADD_MESSAGES,
  RESET_STATE,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  if (type === SET_LOADING) {
    return {
      ...state,
      loading: payload,
    }
  } else if (type === CHANGE_APP_STATE) {
    return {
      ...state,
      appState: {
        ...state.appState,
        ...payload,
      },
    }
  } else if (type === ADD_MESSAGES) {
    return {
      ...state,
      messages: [...state.messages, ...payload],
    }
  } else if (type === RESET_STATE) {
    return {
      ...INITIAL_STATE,
    }
  }

  return state
}
